<template>
  <stepper-content-card
    @skipStep="$emit('skipStep')"
    @changeStep="handleStepChange"
    :dataLoading="dataLoading"
    :step="2"
    imgUrl="https://images.unsplash.com/photo-1589652717406-1c69efaf1ff8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
  >
    <div slot="heading">Your Interests</div>
    <div slot="subheading">Select areas of interest</div>
    <div slot="body">
      <v-row no-gutters>
        <v-col cols="12">
          <v-checkbox v-model="cakeSizes" value="bento" hide-details label="Robotics"></v-checkbox>
          <v-checkbox v-model="cakeSizes" value="mini" hide-details label="Mechanical Systems"></v-checkbox>
          <v-checkbox v-model="cakeSizes" value="half" hide-details label="Machine Learning & AI"></v-checkbox>
          <v-checkbox v-model="cakeSizes" value="onePlus" hide-details label="Embedded Systems"></v-checkbox>
        </v-col>
      </v-row>
    </div>
  </stepper-content-card>
</template>

<script>
import StepperContentCard from "./StepperContentCard";
import { mapGetters } from "vuex";

export default {
  props: ["currentPerson", "dataLoading"],
  data() {
    return {
      cakeSizes: [],
    };
  },
  mounted() {
    this.cakeSizes = [...this.currentPerson.cakeSizes]
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  methods: {
    handleStepChange() {
      if (!this.cakeSizes.length) {
        this.$setSnackbar("Please select at least one option");
        return;
      }

      this.$emit("changeStep", {
        cakeSizes: this.cakeSizes,
      });
    },
  },
  components: {
    StepperContentCard,
  },
};
</script>